@if (visible$ | async) {
  <app-chart-tile
    [title]="'flow-heat-meter-chart-tile.title' | translate"
    [getSeries]="getSeries"
    [options]="options"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
